module.exports = __webpack_public_path__ + "img/c-cach.33b62306.jpeg";